<template>
  <div class="footer">
    <div class="level">
      <div class="item-level text">
        <p>
          Единый контакт-центр
          <br />
          <a href="tel: +7 (85558) 5-66-61">+7 (85558) 5-66-61</a>
        </p>
      </div>
      <div class="item-level list-left">
        <ul>
          <li>ЧОУ ДПО «Центр работ под напряжением</li>
          <li>Россия, Республика Татарстан</li>
          <li>423523, РТ, г. Заинск, пр. Победы, 5, помещение 1000</li>
        </ul>
      </div>
      <div class="item-level list-left">
        <ul>
          <li>тел.: <a target="_blank" href="tel: +7 (85558) 5-66-61">+7 (85558) 5-66-61</a></li>
          <li>e-mail: <a target="_blank" href="mailto: info@lineworker.ru">info@lineworker.ru</a></li>
        </ul>
      </div>
      <!-- <div class="item-level list">
            <ul>
               <li>О нас</li>
               <li>Карьера</li>
            </ul>
         </div>
         <div class="item-level list">
            <ul>
               <li>Поддержка</li>
               <li>Партнёр</li>
            </ul>
         </div>
         <div class="item-level list">
            <ul>
               <li>Карта сайта</li>
               <li>Контакты</li>
            </ul>
         </div> -->
      <!-- <b-field class="item-level social" type="is-info">
                <b-select
                    placeholder="Русский">
                    <option value="1">Русский</option>
                    <option value="2">Неруский</option>
                    <option value="3">Русский</option>
                    <option value="4">Неруский</option>
                    <option value="5">Русский</option>
                    <option value="6">Неруский</option>
                </b-select>
            </b-field> -->
    </div>
    <div class="bottom">
      <img src="@/assets/img/logo_footer.svg" />
      <div class="links">
        <a target="_blank" href="https://www.instagram.com/lineworker.ru/"><i class="icon-instagram"></i></a>
        <a target="_blank" href="#"><i class="icon-facebook"></i></a>
        <a target="_blank" href="#"><i class="icon-vk"></i></a>
        <a target="_blank" href="#"><i class="icon-youtube"></i></a>
      </div>
      <p>Авторские права © 2019</p>
      <p>Условия использования</p>
      <p>Политика конфиденциальности и Политика использования файлов cookie</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBlock'
}
</script>
